const ProgressBar = ({
  progressPercentage = 0,
  className = "",
  fillColor = "#008CFF",
}) => {
  return (
    <div className={`progress-bar-wrapper ${className}`.trim()}>
      <div
        className="progress-bar-fill"
        style={{
          width: `${progressPercentage}%`,
        }}
      ></div>
    </div>
  );
};

export default ProgressBar;
